import { Combobox } from '@src/components'
import { selectDictDetectionPlaceInfection } from '@src/modules/dictionaries/store'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class DetectionPlaceColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.DETECTION_PLACE

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Место выявления',
        component: Combobox,
        props: {
          allowClear: true,
          mode: 'multiple',
          options: selectDictDetectionPlaceInfection(store.getState()).payload?.map(mo => ({
            label: mo.name,
            value: mo.item,
            title: mo.name,
          })),
        },
        defaultValue: [],
      },
      width: 300,
      dataIndex: 'place_of_detection',
      dataRender: place_of_detection => place_of_detection ? place_of_detection : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestArgs = []

    if (filters?.place_of_detection && filters?.place_of_detection.length) {
      requestArgs = [{ field: 'place_of_detection_code', value: filters.place_of_detection, operator: '=', invalid: false, cast: 'right-any' }]
    }

    if (nullSearches[this.type]) {
      requestArgs = [{ field: 'place_of_detection_code', operator: '=', value: null, invalid: false }]
    }

    return {
      control: {
        filters: requestArgs,
      },
    }
  }
}
